var alertTriggerToggle = {
	add: "Add trigger",
	edit: "Edit trigger",
	label: {
		addAlert: "Add alert",
		upperLimit: "Upper limit",
		lowerLimit: "Lower limit",
		upperLimitCrossed: "Upper limit crossed",
		lowerLimitCrossed: "Lower limit crossed"
	}
};
var en = {
	alertTriggerToggle: alertTriggerToggle
};

export { alertTriggerToggle, en as default };
